// Spec 2: the server refuses public profile text it doesn't read as kind
// (error 'unkind') and names the blocklist refuses ('invalid_name'), naming
// the one field it is about. ProfilePanel shows the message under that field.
const REFUSALS = ['unkind', 'invalid_name']
const DEFAULT_MESSAGE = "That didn't read as kind. These words are public. Try rephrasing."

export function profileFieldRejection(error) {
  const { status, data } = error?.response || {}
  if (status !== 400 || !REFUSALS.includes(data?.error) || !data?.field) return null
  return { field: data.field, message: data.message || DEFAULT_MESSAGE }
}
